import React from 'react';
import PropTypes from 'prop-types';
import Card from 'common/card/Card';
import AccessHours from 'spot-details/access/AccessHours';

const HoursCardPanel = ({
    facility,
    selectedRate
}) => {
    return (
        <Card
            className="HoursCardPanel"
            title="Hours of Operation"
        >
            <AccessHours
                facility={facility}
                rate={selectedRate}
            />
        </Card>
    );
};

HoursCardPanel.propTypes = {
    facility: PropTypes.object.isRequired,
    selectedRate: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.bool
    ]).isRequired
};

export default HoursCardPanel;
